import type {CrmRestaurantMainInfo} from "../types"

export class Restaurant implements Restaurant {
  restaurantId: string
  restaurantTitle: string
  restaurantLogoUrl: string
  info: CrmRestaurantMainInfo

  constructor(data: {
    restaurants_id: string
    restaurants_title: string
    restaurants_logo_url: string
    info: CrmRestaurantMainInfo
  }) {
    this.restaurantId = data.restaurants_id
    this.restaurantTitle = data.restaurants_title
    this.restaurantLogoUrl = data.restaurants_logo_url
    this.info = data.info
  }
}
